export default __webpack_public_path__ + "static/media/cc18.b2cd8e68.png";